import { MapLocation } from "./SuperclusterManager";

interface CachedMapLocation extends MapLocation {
  // Removed timestamp property
}

export class RestoCache {
  private allLocations: Map<string, CachedMapLocation> = new Map();

  addToCache(locations: MapLocation[]): void {
    let addedCount = 0;

    locations.forEach((loc) => {
      if (!this.allLocations.has(loc.id)) {
        this.allLocations.set(loc.id, {
          ...loc,
        });
        addedCount++;
      }
    });

  }

  getLocationsInBounds(
    bounds: google.maps.LatLngBounds,
    forks?: number[],
  ): MapLocation[] {
    const boundsJson = bounds.toJSON();
    const results: MapLocation[] = [];


    this.allLocations.forEach((cachedLoc) => {
      const isInBounds =
        cachedLoc.lat <= boundsJson.north &&
        cachedLoc.lat >= boundsJson.south &&
        cachedLoc.lng <= boundsJson.east &&
        cachedLoc.lng >= boundsJson.west;

      let meetsForkCriteria;
      if (forks === undefined) {
        meetsForkCriteria = true;
      } else if (forks.length === 0) {
        meetsForkCriteria = false;
      } else {
        const locationForkValue = Number(cachedLoc.entry?.inspectionForks);
        meetsForkCriteria = !isNaN(locationForkValue) && forks.includes(locationForkValue);
      }

      if (isInBounds && meetsForkCriteria) {
        results.push(cachedLoc);
      }
    });

    return results;
  }

  clearCache(): void {
    this.allLocations.clear();
  }

  getTotalEntries(): number {
    return this.allLocations.size;
  }
}

export default RestoCache;
